import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import currentService from '../services/current-stock.services';
import {setMessage} from './message';

export const fetchCurrentStockDataList = createAsyncThunk(
  'currentStock/fetchCurrentStockDataList',
  async ({page, pagesize, search, ordering}, thunkAPI) => {
    try {
      const response = await currentService.getCurrentStockDataList(
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data; // Access the nested data array
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);
export const fetchInCurrentStockExcessStockDataList = createAsyncThunk(
  'currentStock/fetchInCurrentStockExcessStockDataList',
  async ({page, pagesize, search, ordering}, thunkAPI) => {
    try {
      const response =
        await currentService.getInCurrentStockExcessStockDataList(
          page,
          pagesize,
          search,
          ordering,
        );
      return response.data; // Access the nested data array
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const fetchCurrentStockByCompanyId = createAsyncThunk(
  'currentStock/fetchCurrentStockByCompanyId',
  async ({page, pagesize, search, ordering, id}, thunkAPI) => {
    try {
      const response = await currentService.getCurrentStockByCompanyId(
        page,
        pagesize,
        search,
        ordering,
        id,
      );
      return response.data; // Access the nested data array
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const fetchCurrentStockByCompanyIdDetails = createAsyncThunk(
  'currentStock/fetchCurrentStockByCompanyIdDetails',
  async ({page, pagesize, search, ordering, id}, thunkAPI) => {
    try {
      const response = await currentService.getCurrentStockByCompanyIdDetails(
        page,
        pagesize,
        search,
        ordering,
        id,
      );
      return response.data; // Access the nested data array
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const fetchCurrentStockItemList = createAsyncThunk(
  'currentStock/fetchCurrentStockItemList',
  async ({page, pagesize, search, ordering, id}, thunkAPI) => {
    try {
      const response = await currentService.getCurrentStockDataItemList(
        page,
        pagesize,
        search,
        ordering,
        id,
      );
      return response.data; // Access the nested data array
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const fetchCurrentStockItemWiseSummary = createAsyncThunk(
  'currentStock/fetchCurrentStockItemWiseSummary',
  async ({page, pagesize, search, ordering, id}, thunkAPI) => {
    try {
      const response = await currentService.getCurrentStockItemWiseSummary(
        page,
        pagesize,
        search,
        ordering,
        id,
      );
      return response.data; // Access the nested data array
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const deleteCurrentStockList = createAsyncThunk(
  'currentStock/deleteCurrentStockList',
  async (id, thunkAPI) => {
    try {
      await currentService.deleteCurrentStockList(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

const initialState = {
  data: [],
  dataCounts: {},
  list: [],
  loading: false,
  totalRecords: 0,
  totalRecordTwo: 0,
  currentPage: 1,
  totalPages: 0,
  totalPagesTwo: 0,
  status: 'idle',
  error: null,
  hasMore: true,
  excessStockPackedWeightInCurrentStock: null,
};

const currentStockSlice = createSlice({
  name: 'currentStock',
  initialState,
  reducers: {
    resetCurrentStockList: state => {
      state.list = []; // Reset the list
      state.currentPage = 1; // Reset to first page
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchCurrentStockDataList.pending, state => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(fetchCurrentStockDataList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.loading = false;
        const newData = action.payload?.results.data.customer_details || []; // Ensure it's an array
        const newDatacount = action.payload?.results.data.counts || []; // Ensure it's an array
        state.dataPartyWise = newData;
        state.dataPartyWiseCounts = newDatacount; // Store the latest fetched data
        state.list = [...state.list, ...newData]; // Append new data to the list
        const fetchedPage = action.payload.page || state.currentPage;
        state.totalRecordsPartyWise = action.payload.count || 0;
        state.totalPages = Math.ceil(
          (action.payload.count || 0) / action.meta.arg.limit,
        ); // Set total records
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.hasMore = !!action.payload.next; // Check if there are more records
      })
      .addCase(fetchCurrentStockDataList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchInCurrentStockExcessStockDataList.pending, state => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(
        fetchInCurrentStockExcessStockDataList.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
         
          // Ensure the data is
          state.excessStockPackedWeightInCurrentStock =
            action.payload.data.packed_weight || null;
          // const newData = action.payload?.results.data.customer_details || []; // Ensure it's an array
          // const newDatacount = action.payload?.results.data.counts || []; // Ensure it's an array
          // state.dataPartyWise = newData;
          // state.dataPartyWiseCounts = newDatacount; // Store the latest fetched data
          // state.list = [...state.list, ...newData]; // Append new data to the list
          // const fetchedPage = action.payload.page || state.currentPage;
          // state.totalRecordsPartyWise = action.payload.count || 0;
          // state.totalPages = Math.ceil(
          //   (action.payload.count || 0) / action.meta.arg.limit,
          // ); // Set total records
          // state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
          // state.hasMore = !!action.payload.next; // Check if there are more records
        },
      )
      .addCase(
        fetchInCurrentStockExcessStockDataList.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.error.message;
        },
      );

    builder
      .addCase(fetchCurrentStockByCompanyId.pending, state => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(fetchCurrentStockByCompanyId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.loading = false;

        const newData = action?.payload?.results?.data || [];

        state.dataPartyWiseSummary = newData; // Store the latest fetched data
        state.list = [...state.list, ...newData]; // Append new data to the list
        state.totalRecords = newData.length; // Set total records
        const fetchedPage = action.payload?.page || state.currentPage;
        state.totalRecords = action.payload?.count || 0;
        state.totalPages = Math.ceil(
          (action.payload.count || 0) / action.meta.arg.limit,
        ); // Set total records
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchCurrentStockByCompanyId.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchCurrentStockByCompanyIdDetails.pending, state => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(
        fetchCurrentStockByCompanyIdDetails.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;

          const newData = action.payload?.results.data || []; // Ensure it's an array
          state.dataTwo = newData; // Store the latest fetched data
          state.list = [...state.list, ...newData]; // Append new data to the list
          state.totalRecordTwo = newData.length; // Set total records
          const fetchedPage = action.payload?.page || state.currentPage;
          state.totalRecordTwo = action.payload?.count || 0;
          state.totalPages = Math.ceil(
            (action.payload.count || 0) / action.meta.arg.limit,
          ); // Set total records
          state.currentPage = action.payload.next
            ? fetchedPage + 1
            : fetchedPage;
          state.hasMore = !!action.payload.next;
        },
      )
      .addCase(
        fetchCurrentStockByCompanyIdDetails.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.error.message;
        },
      );

    builder
      .addCase(fetchCurrentStockItemList.pending, state => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(fetchCurrentStockItemList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.loading = false;

        const newData = action.payload?.results.data || [];
        state.dataCurrentStock = newData?.bundles; // Store the latest fetched data
        state.dataCurrentStockCounts = newData?.counts;
        state.list = [...state.list, ...newData?.bundles]; // Append new data to the list
        const fetchedPage = action.payload?.page || state.currentPage;
        state.totalRecordsCurrentStock = action.payload?.count || 0;
        state.totalPages = Math.ceil(
          (action.payload.count || 0) / action.meta.arg.limit,
        ); // Set total records
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchCurrentStockItemList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchCurrentStockItemWiseSummary.pending, state => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(fetchCurrentStockItemWiseSummary.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.loading = false;

        const newData = action.payload?.results.data || [];
        state.dataSummary = newData?.summary; // Store the latest fetched data
        state.dataSummarycount = newData?.counts; // Store the latest fetched data
        state.list = [...state.list, ...newData?.summary]; // Append new data to the list
        const fetchedPage = action.payload?.page || state.currentPage;
        state.totalPages = Math.ceil(
          (action.payload.count || 0) / action.meta.arg.limit,
        ); // Set total records

        state.totalRecordsSummaryWise = action.payload?.count || 0;
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchCurrentStockItemWiseSummary.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const {resetCurrentStockList} = currentStockSlice.actions;
export default currentStockSlice.reducer;
